import React from "react";
import { useEffect } from "react";
import "../../styles/style_videoHeader.css";
import { API } from '../../api';

export default function VideoHeader({ data }) {

  useEffect(() => {
    const video = document.querySelector(".VH_video");
    const overlay = document.querySelector(".VH_overlay");
    if (video && overlay) {
      video.addEventListener("loadeddata", () => {
        overlay.classList.add("loaded"); 
      });
    }
  }, []);

  return (
    <header id="evenement" className="VH_container">
      <video className="VH_video" src={`${API.API_LINK}${data.video_top_url}`} autoPlay loop muted />

      <div className="VH_overlay">
        <h1 className="VH_title">Votre fleuriste au Cap d’Agde</h1>
        <p className="VH_subtitle">Bouquets, compositions florales & créations sur-mesure</p>

        <div className="VH_stats">
          <div className="VH_stat">
            <span className="VH_number">+ {data.stats.years_of_passion}</span>
            <span className="VH_label">Années de passion</span>
          </div>
          <div className="VH_stat">
            <span className="VH_number">+ {data.stats.bouquets_created}</span>
            <span className="VH_label">Bouquets réalisés</span>
          </div>
          <div className="VH_stat">
            <span className="VH_number">{data.stats.client_rating} ★</span>
            <span className="VH_label">Avis clients</span>
          </div>
        </div>
      </div>
    </header>
  );
}